import Reveal from "@/components/Reveal";

import atmosphericImg from "@/assets/island-peninsula-view.jpg";

/**
 * A slow cinematic pause between dense homepage sections.
 * Large image, soft overlay, minimal copy — an emotional breath.
 * Tuned for meditative pacing on every viewport.
 */
const AtmosphericBreak = () => {
  return (
    <section
      aria-label="A quiet moment"
      className="relative overflow-hidden bg-[hsl(150_35%_6%)]"
    >
      <div className="relative min-h-[68vh] md:min-h-[78vh] flex items-center justify-center py-24 md:py-32">
        <img
          src={atmosphericImg}
          alt=""
          aria-hidden
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover opacity-90 scale-105"
          style={{ animation: "drift-break 30s ease-in-out infinite alternate" }}
        />
        <div
          aria-hidden
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, hsl(150 35% 6% / 0.7) 0%, hsl(150 35% 6% / 0.55) 50%, hsl(150 35% 6% / 0.82) 100%)",
          }}
        />
        {/* Stitch fades */}
        <div
          aria-hidden
          className="absolute top-0 inset-x-0 h-28 md:h-32 pointer-events-none"
          style={{
            background:
              "linear-gradient(180deg, hsl(var(--background)) 0%, transparent 100%)",
          }}
        />
        <div
          aria-hidden
          className="absolute bottom-0 inset-x-0 h-28 md:h-32 pointer-events-none"
          style={{
            background:
              "linear-gradient(180deg, transparent 0%, hsl(var(--background)) 100%)",
          }}
        />


        <Reveal className="relative z-10 text-center px-6 max-w-2xl">
          <p className="font-sans text-[11px] tracking-[0.42em] uppercase text-accent mb-7 md:mb-8">
            An Island Breath
          </p>
          <p
            className="font-serif italic text-[2rem] leading-[1.18] md:text-5xl text-[hsl(40_33%_97%)]"
            style={{ textShadow: "0 2px 28px hsl(150 35% 6% / 0.75)" }}
          >
            Caribbean wellness was once a way of life.
            <br />
            <span className="text-accent not-italic font-normal text-xl md:text-3xl block mt-6 md:mt-7 tracking-[0.04em]">
              Some traditions still live here.
            </span>
          </p>
        </Reveal>
      </div>
      <style>{`
        @keyframes drift-break {
          0% { transform: scale(1.05) translate3d(0,0,0); }
          100% { transform: scale(1.12) translate3d(-1.5%, -1%, 0); }
        }
      `}</style>
    </section>
  );
};

export default AtmosphericBreak;
